import { styled } from '@mui/material/styles';

const SIZES = {
  small: '2.375em',
  medium: '4.25em',
  large: '9.25em'
};

export const Image = styled('img')(({ theme, size }) => ({
  backgroundColor: theme.color.primary.contrast,
  borderRadius: '50%',
  height: SIZES[size],
  objectFit: 'cover',
  width: SIZES[size]
}));
